import React from 'react';

function MigrateDynamicTextItems({ currentEditItem, handleChange }) {
    // Convert dynamic text content property
    // `label` to `content`
    // to provide backward compatibility
    React.useEffect(() => {
        const { dynamicText } = currentEditItem;
        const found = dynamicText?.items?.find((item) => item.label);
        if (found) {
            const value = dynamicText.items.map((item) => ({
                id: item.id,
                content: item.label,
            }));

            handleChange({
                value,
                name: 'dynamicText/items',
            });
        }
    }, []);

    return null;
}

export default MigrateDynamicTextItems;
